import { useStatsig } from '@atlassian/mpac-feature-flags';

export const useRegulatedSectorFeatureFlags = () => {
  const { enableIsolatedCloudChanges, enableRegulatedSectorMenuButtonForFedramp } = useStatsig();
  return {
    enableIsolatedCloudChanges: enableIsolatedCloudChanges(),
    showFedrampNavigationMenuButton: enableRegulatedSectorMenuButtonForFedramp(),
  };
};
